import type { DistributorQualifyingAnswers } from '@/api/vendo';

export interface ApprovalScoreInput {
   facebookUrl?: string | null;
   mayorsPermitUrl?: string | null;
   bir2303Url?: string | null;
   proofOfAddressUrl?: string | null;
   qualifyingAnswers?: DistributorQualifyingAnswers | null;
}

/**
 * Approval-chance preview used by both the apply form and the
 * post-submit "awaiting review" card so they always show the same number.
 *
 * Base 30 (covers profile + required gov ID already gated by submit),
 * +5 per "yes" qualifying answer (10 × 5 = 50 max),
 * +5 per optional doc supplied (3 × 5 = 15),
 * +5 for a valid Facebook URL.
 */
export function computeApprovalScore(input: ApprovalScoreInput): number {
   let score = 30;

   const answers = input.qualifyingAnswers;
   if (answers) {
      const yesCount = Object.values(answers).filter(Boolean).length;
      score += yesCount * 5;
   }

   if (input.mayorsPermitUrl) score += 5;
   if (input.bir2303Url) score += 5;
   if (input.proofOfAddressUrl) score += 5;

   if (
      input.facebookUrl &&
      /^https?:\/\/(www\.)?facebook\.com\//i.test(input.facebookUrl)
   ) {
      score += 5;
   }

   return Math.min(100, Math.round(score));
}
